<template>
  <modal
    :show.sync="isOpenLocal"
    scrollable
    header-classes="bg-primary p-2 flex items-center"
    size="md"
    @close="handleClose"
  >
    <!-- <h6 slot="header" class="modal-title text-white pl-4 font-semibold">
      Add News
    </h6> -->

    <h6 class="modal-title text-black font-semibold">About Me</h6>

    <div>
      <quill-editor
        v-model="body"
        :options="editorOption"
        class="quill-h200px my-2"
      />
    </div>
    <template slot="footer" class="justify-center">
      <base-button type="primary" @click="handleClick(user)"
        >SAVE CHANGES</base-button
      >
      <base-button type="secondary" class="ml-auto border" @click="handleClose"
        >CLOSE</base-button
      >
    </template>
  </modal>
</template>

<script>
import { mapState } from "vuex";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
export default {
  components: {
    quillEditor,
  },
  data() {
    return {
      editorOption: {
        theme: "snow",
        modules: {
          toolbar: [
            ["bold", "italic", "underline"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ align: [] }],
            [{ color: [] }, { background: [] }],
          ],
        },
      },
      body: "",
    };
  },
  props: {
    isOpen: Boolean,
    data: { type: Object },
  },
  computed: {
    ...mapState("auth", {
      user: "user",
    }),
    ...mapState("eLearning", {
      profileData: "profileData",
    }),
    isOpenLocal: {
      get() {
        return this.isOpen;
      },
      set(val) {
        if (!val) {
          this.handleClose();
        }
      },
    },
  },
  methods: {
    async handleClose() {
      let userid = {
        userId: this.user._id,
      };
      await this.$store.dispatch("eLearning/getProfile", userid);
      this.$emit("close");
    },
    async handleClick(user) {
      // this.split1 = this.body.split("<p>");
      // this.split2 = this.split1[1].split("</p>");

      let payload = {
        _id: user._id,
        bios: this.body,
      };

      setTimeout(() => {
        this.handleClose();
      }, 1000);

      const newdata = await this.$store.dispatch("eLearning/editUser", payload);

      // if (user.roll === "student") {
      //   this.editStudentDetail();
      // } else {
      //   this.editAuthorDetail();
      // }
    },
    async editStudentDetail() {
      const payload = {
        aboutMe: this.body,
        _id: this.data._id,
      };
      const payload2 = {
        userId: this.data._id,
      };
      const data = await this.$store.dispatch("student/editStudents", payload);

      if (data.code == 200) {
        await this.$store.commit("auth/UPDATE_USERDATA_INFO", data.data);
      }
      this.handleClose();
    },
    aboutMe() {
      if (this.userData.student) {
        this.body = this.data.student.aboutMe;
      } else {
        this.body = this.data.aboutMe;
      }
    },
  },
  async mounted() {
    this.aboutMe();
    // alert(this.profileData.bios);
  },
};
</script>
